import angular from 'angular';
import DoctorFilterComponent from './doctor-filter.component';

const doctorFilter = angular
	.module('doctorFilter', [])
	.component('doctorFilter', DoctorFilterComponent)
	.name;

export default doctorFilter;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-filter/doctor-filter.module.js